<template>
 <div >
    <h2>Sign up</h2>
    <template v-if="$store.getters.signUpAllowed">
        <SignUpForm v-if="!$store.getters.isLoggedIn" />
        <div v-else>
            <p>You are already signed up and logged in</p>
            <LogoutButton />
        </div>
    </template>
    <p v-else>
        Signing up for listoliby is currently closed.
    </p>
 </div>
</template>

<script>
import SignUpForm from '@/components/forms/signup-form.vue'
import LogoutButton from '@/components/forms/logout-button.vue'


export default {
    name: 'SignUp',
    components: {
        SignUpForm,
        LogoutButton
    }
}
</script>
